/* @jsxImportSource react */

import React from 'react';

import { cn } from '../../utils/cn/cn';

export type RatingStarProps = {
  /** normalized from 0 to 1 */
  fillPercentage?: number;
};

export const RatingStar = ({
  fillPercentage,
  className,
  ...props
}: RatingStarProps & React.HTMLAttributes<HTMLSpanElement>) => (
  <div {...props} className={cn('relative h-2 w-2', className)}>
    <span className="icon-emp-star-outline absolute inset-0" />
    <span
      className="icon-emp-star absolute inset-0"
      style={{ clipPath: `inset(0 ${100 - (fillPercentage ?? 1) * 100}% 0 0)` }}
    />
  </div>
);
